// Third Party Library
import React, { useState } from "react";
import { Layout, Space, Col, Form, Input, message, Card } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// Constants
import { ROUTE } from "../../../../constants";

// Style
import styles from "../../../index.module.css";

// Components
import { LoginHeader, CopyRightFooter } from "../../../../components";

import SSOFPFooter from "../SSOFPFooter";

import * as ACTIONS from "../../../../services/redux/actions";

const { Content } = Layout;
const { MODULE_ROUTE } = ROUTE;

const SSOForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const [loadingReset, setLoadingReset] = useState(false);

  const onFinish = () => {
    form.validateFields().then((value) => {
      const { email } = value;
      messageApi.open({
        type: "loading",
        content: "Sending to your email...",
        duration: 0,
      });

      dispatch(
        ACTIONS.main_user.sso_user_auth_reset_password_verify_email_request(
          email,
          ({ status, err }) => {
            if (status === 200) {
              messageApi.destroy();
              setLoadingReset(false);
              navigate(MODULE_ROUTE.FORGOT_PASSWORD_6_DIGITS_CODE);
            } else {
              messageApi.destroy();
              setLoadingReset(false);
              message.error(err);
            }
          }
        )
      );
      setLoadingReset(true);
    });
  };

  return (
    <>
      {contextHolder}
      <div className={styles.mainWrap}>
        <Card className={styles.mainCard}>
          <Space
            direction="vertical"
            style={{ width: "100%", textAlign: "center" }}
            size={[0, 48]}
          >
            <Layout style={{ backgroundColor: "#ffffff" }}>
              <LoginHeader />

              <Content style={{ marginTop: "40px" }}>
                <Col span={8} offset={8}>
                  <h2 className={styles.textTitle}>Forget Password</h2>

                  <p className={styles.textDetailsForgetPass}>
                    Enter your email associated with your account and we will
                    send a 6 digits code to reset your password.
                  </p>

                  <Form
                    form={form}
                    name="normal_login"
                    initialValues={{
                      remember: true,
                    }}
                    layout="vertical"
                  >
                    <label htmlFor="name" className={styles.labelInput}>
                      Email <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Item
                      name="email"
                      rules={[
                        {
                          type: "email",
                          message: "The input is not valid email!",
                        },
                        {
                          required: true,
                          message: "Please input your email!",
                        },
                      ]}
                    >
                      <Input
                        className={styles.inputMain}
                        allowClear
                        type="email"
                      />
                    </Form.Item>
                  </Form>
                </Col>
              </Content>
              <SSOFPFooter
                loading={loadingReset}
                page={MODULE_ROUTE.Login}
                submit={onFinish}
              />
            </Layout>
          </Space>
        </Card>

        <CopyRightFooter />
      </div>
    </>
  );
};

export default SSOForgotPassword;
